module.exports = __webpack_public_path__ + "img/logoNav.17163b80.png";